import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  DELETE_FEEDBACK_REQUEST,
  DELETE_FEEDBACK_SUCCESS,
  DELETE_FEEDBACK_FAILURE,
  GET_FEEDBACK_LIST_REQUEST,
  GET_FEEDBACK_LIST_SUCCESS,
  GET_FEEDBACK_LIST_FAILURE,
} from "../constants/feedbackConstant";

// Action to delete feedback
export const deleteFeedbackAction = (feedbackId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_FEEDBACK_REQUEST });
    const URL = `${ApiUrl.deleteFeedback}?feedbackId=${feedbackId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_FEEDBACK_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_FEEDBACK_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
  }
};

// Action to get the list of feedback
export const getFeedbackListAction = () => async (dispatch) => {
  try {
    dispatch({ type: GET_FEEDBACK_LIST_REQUEST });
    const URL = ApiUrl.getFeedbackList;
    const { data } = await axios.get(URL);

    if (data.success) {
      dispatch({
        type: GET_FEEDBACK_LIST_SUCCESS,
        payload: data.response, // Assuming data.response contains the list of feedback
      });
      return data;
    }
  } catch (error) {
    dispatch({
      type: GET_FEEDBACK_LIST_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
  }
};
